import services from './config';
export default services;
